import { ActionTypes as action } from "./action-types";
import searchService from "../../../api/searchService";

const actions = {
    async getSearchResults({ commit, state }, query) {
        state.Loaderloading = true
        const data = await searchService.getSearchResults(query);
        commit(action.GET_SEARCH_RESULT, data);
        state.Loaderloading = false
        return data;
    },
    setDocumentHeaders({ commit }, data) {
        let documentSearchHeader = `document_search_header#${localStorage.getItem('tenantId')}`;
        if (!data) {
            data = localStorage.getItem(documentSearchHeader) ? JSON.parse(localStorage.getItem(documentSearchHeader)) : [];
        } else {
            localStorage.setItem(documentSearchHeader, JSON.stringify(data));
        }
        commit(action.SET_DOCUMENT_HEADERS, data);
    },
    resetState({ commit }) {
        commit(action.RESET_STATE);
    },
};

export default actions;
